export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        // Gli errori Vue non devono piu' passare in silenzio: log in console
        // (punto di aggancio per un eventuale servizio di segnalazione).
        console.error("[vue error]", info, error);
    };
});
